import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractTextInput} from "../abstract-text-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditTextInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-text-input",
    styleUrls: ["./edit-text-input.component.scss"],
    templateUrl: "./edit-text-input.component.html"
})
export class FUIEditTextInputComponent extends FUIAbstractTextInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, changeDetectorRef);
    }
}
